import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../UiElement/FormElement/Input";
import { EventLanguage } from "../../../utils/Languages";
import AddedTagList from "./AddTagList";
import useHttpHook from "../../../Hooks/HttpHook";
import timezones from "../../../assets/timezone.json";
import {
  CreateBasicInfoApi,
  UpdateBasicInfoApi,
  EventById,
  CountriesList,
  CategoriesList,
} from "../../../utils/ApiConstant";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import SubmitButtonGroup from "../../UiElement/FormElement/SubmitBtnGroup";
import { updEventData } from "../../../ReduxSlice/Event/eventSlice";
import LocationMap from "./LocationMap";
import moment from "moment";
import { toast } from "react-toastify";
import {
  checkEventValidityWithTicket,
  combineDateAndTime,
  combineDateTime,
} from "../../../utils/Helper";
import { showErrorToast } from "../../../utils/notify";
const BasicInfoForm = () => {
  const [loading, sendRequest, error] = useHttpHook();
  const [EventData, setEventData] = useState();
  const [countries, setCountriesList] = useState();
  const [categories, setCategoriesList] = useState();
  const [eventType, setEventType] = useState("single");
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm();
  const FormLabal = EventLanguage.EventForm.BasicInFoForm.FormLabal;
  const FormText = EventLanguage.EventForm.BasicInFoForm;
  const [dateTimeError, setDateTimeError] = useState("");
  const [ticketValidityError, setTicketValidityError] = useState(null);
  const [customError, setCustomError] = useState(null);
  const { eventId } = useParams();

  useEffect(() => {
    getCountries();
    getCategories();
  }, []);

  console.log(errors, "------------- errors ----");

  const [a, setA] = useState([]);
  const [address, setAddress] = useState({
    city: "",
    address: "",
    state: "",
    country: "",
    postalCode: "",
  });
  const [locationError, setLocationError] = useState({});
  useEffect(() => {
    setA(
      timezones.timeZones?.map((item) => {
        return {
          LabelText: item,
          value: item,
        };
      })
    );
  }, []);

  const resetDetails = () => {
    console.log("resetform");
    dispatch(
      updEventData({
        data: {},
        status: false,
        isEdit: false,
      })
    );
    const defaultFormValues = {
      eventDayType: "",
      evtTitle: "",
      TagData: "",
      category: "",
      address: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
      evtStartDate: "",
      evtEndDate: "",
      evtStartTime: "",
      evtEndTime: "",
      displayStartTime: "",
      displayEndTime: "",
      timezone: "Time Zone: (GMT+07:30) Pacific Time",
    };
    reset(defaultFormValues);
  };

  useEffect(() => {
    console.log({ eventId });
    if (eventId) {
      getEventData();
    }

    if (eventId === undefined) {
      resetDetails();
    }
  }, [eventId]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  if (
    (EventData && EventData.data.eventTiming.eventDayType === "multi") ||
    eventType === "multi"
  ) {
    console.log("multi");
  }

  const getCountries = async () => {
    let countriesList = await sendRequest(CountriesList, { method: "get" });
    setCountriesList(countriesList.data);
  };
  const getCategories = async () => {
    let categoriesList = await sendRequest(CategoriesList, { method: "get" });
    setCategoriesList(categoriesList.data);
  };
  const getEventData = async () => {
    let event = await sendRequest(EventById + eventId);
    // console.log({ event });
    setEventData(event);
    dispatch(
      updEventData({
        ...event,
        isEdit: true,
      })
    );
    setEventType(event.data.eventTiming.eventDayType || "");
    setAddress(event.data.location);
    const defaultFormValues = {
      eventDayType: event.data.eventTiming.eventDayType || "",
      evtTitle: event.data.title || "",
      TagData: event.data.tag || "",
      category: event.data.category || "",
      address: event.data.location.address || "",
      city: event.data.location.city || "",
      state: event.data.location.state || "",
      postalCode: event.data.location.postalCode || "",
      country: event.data.location.country || "",
      evtStartDate:
        new Date(event.data.eventTiming.startDate)
          .toISOString()
          .split("T")[0] || "",
      evtEndDate:
        new Date(event.data.eventTiming.endDate).toISOString().split("T")[0] ||
        "",
      evtStartTime: event.data.eventTiming.startTime || "",
      evtEndTime: event.data.eventTiming.endTime || "",
      displayStartTime: event.data.eventTiming.displayStartTime || "",
      displayEndTime: event.data.eventTiming.displayEndTime || "",
      eventDayType: event.data.eventTiming.eventDayType || "",
      timeZone: event.data.eventTiming.timeZone || "",
    };
    setEventType(event.data.eventTiming.eventDayType);
    reset(defaultFormValues);
  };
  const AddTagClickHandler = (e) => {
    let TagData = watch("TagData") ? watch("TagData") : watch("evtTag").split();
    if (watch("TagData") && watch("evtTag")) {
      TagData.push(watch("evtTag"));
    }
    if (watch("evtTag") != "") {
      setValue("TagData", TagData);
      setValue("evtTag", "");
    }
  };

  const removeTagHandler = (TagName) => {
    let TagData = watch("TagData");
    TagData.pop(TagName);
    setValue("TagData", TagData);
  };

  const onSubmit = async (data) => {
    if (EventData) {
      const {
        data: {
          ticketType,
          eventTiming: { eventDayType },
        },
      } = EventData;

      let eventDate = new Date(
        eventDayType === "single" ? data.evtStartDate : data.evtEndDate
      );

      const eventStartDate = new Date(data?.evtStartDate);

      const [hour, minute] = data?.evtEndTime.split(":");
      const combinedEventDateTime = combineDateTime(eventDate, hour, minute);
      const combinedEventStartDateTime = combineDateTime(
        eventStartDate,
        hour,
        minute
      );
      const eventStartDateTime = moment
        .utc(combinedEventStartDateTime)
        .format("YYYY-MM-DD HH:mm");
      const eventEndDateTime = moment
        .utc(combinedEventDateTime)
        .format("YYYY-MM-DD HH:mm");

      // const eventEndDateTime = combineDateAndTime(
      //   eventDayType === "single" ? data.evtStartDate : data.evtEndDate,
      //   hour,
      //   minute
      // );

      if (ticketType?.length) {
        const { checkEventValidity, msg } = checkEventValidityWithTicket(
          ticketType,
          eventEndDateTime,
          eventStartDateTime
        );
        if (checkEventValidity) {
          setTicketValidityError(msg);

          return;
        }
      }
    }

    const currentDate = moment(new Date()).format("YYYY-MM-DD");
    const eventStartDate = moment(data.evtStartDate).format("YYYY-MM-DD");
    const eventEndDate = moment(data.evtEndDate).format("YYYY-MM-DD");
    const eventStartTime = data.evtStartTime;
    const eventEndTime = data.evtEndTime;
    if (!eventId) {
      if (eventStartDate < currentDate) {
        toast.error("Event Start Date should be greater than current date");
        return;
      }
    }

    if (eventType === "multi" && eventStartDate > eventEndDate) {
      toast.error("Event Start Date should not be greater than Event End Date");
      return;
    }
    if (eventType === "multi" && eventStartDate === eventEndDate) {
      toast.error(
        "Event start  and end date should not be same in event multi type."
      );
      return;
    }

    if (
      eventType === "multi" &&
      eventStartDate == eventEndDate &&
      eventStartTime > eventEndTime
    ) {
      toast.error("Event start time should not be greater than Event end time");
      return;
    }

    // if (eventType === "single" && eventStartDate >= eventEndDate) {
    //   toast.error("Event Start Date should not be greater than Event End Date");
    //   return;
    // }

    if (eventType === "single" && eventStartTime >= eventEndTime) {
      toast.error("Event Start Time should not be greater than Event End Time");
      return;
    }

    if (eventType === "multi" && eventStartDate > eventEndDate) {
      toast.error("Event Start Date should not be greater than Event End Date");
      return;
    }

    if (!!Object.keys(address)?.length) {
      console.log(address, "- adres ");
      Object.keys(address)?.map((key) => {
        console.log(key, "- key -");
        if (address["address"] === "") {
          setLocationError((prev) => {
            return { ...prev, address: `Address is required.` };
          });
        }
        if (address["city"] === "") {
          setLocationError((prev) => {
            return { ...prev, city: `City is required.` };
          });
        }
        if (address["state"] === "") {
          setLocationError((prev) => {
            return { ...prev, state: `State is required.` };
          });
        }
        if (address["postalCode"] === "") {
          setLocationError((prev) => {
            return { ...prev, postalCode: `Postal Code is required.` };
          });
        }
        if (address["country"] === "") {
          setLocationError((prev) => {
            return { ...prev, country: `Country is required.` };
          });
        }
      });
    }

    if (!address.country) {
      setLocationError((prev) => {
        return { ...prev, country: "Country is required." };
      });
      return;
    }

    if (eventType === "single") {
      const dateIsBefore = moment(
        `${moment(data.startDate).format("YYYY-MM-DD")}T${data.evtStartTime}:00`
      ).isBefore(
        moment(
          `${moment(data.endDate).format("YYYY-MM-DD")}T${data.evtEndTime}:00`
        )
      );

      if (!dateIsBefore) {
        toast.error(
          "Start Time should not be equal and greater than end time."
        );
        return;
      }
    }

    let obj = {
      ...data,
      eventDayType: eventType,
      ...address,
    };

    // console.log({ obj });

    let event = await sendRequest(
      eventId ? UpdateBasicInfoApi + eventId : CreateBasicInfoApi,
      { method: "post", data: obj }
    );
    // console.log(event)
    if (event.status === 1) {
      dispatch(updEventData(event));
      setAddress({});
      navigate(`/myEvents/${event.data._id}/details`, { replace: true });
    }
  };

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="evntFormUI">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="evntUserInfo bg-F9F9F9">
            <div className="heading">
              <h4>{EventLanguage.EventForm.BasicInFoForm.FormTitle}</h4>
            </div>
            <Input
              element="text"
              placeholder={FormLabal.evtTitle.placeholder}
              defValue={EventData && EventData.data.title}
              Register={register}
              Errors={errors}
              FieldName="evtTitle"
              Label={FormLabal.evtTitle.label}
              ValidationArr={[
                { Type: "required" },
                { Type: "minLength", value: 3 },
                { Type: "maxLength", value: 50 },
              ]}
            />
            <Input
              element="select"
              Label={FormLabal.category.label}
              FieldName="category"
              options={categories}
              optionValue="category"
              optionLabel="category"
              Register={register}
              Errors={errors}
              ValidationArr={[{ Type: "required" }]}
            />
            <div className="event-create-tags">
              <Input
                CustomFormGroupCls="event-create-field"
                InputClassName="event-create-input"
                element="text"
                placeholder={FormLabal.evtTag.placeHolder}
                Register={register}
                Errors={errors}
                FieldName="evtTag"
                Label={FormLabal.evtTag.label}
              />
              <Input
                element="hidden"
                Register={register}
                Errors={errors}
                FieldName="TagData"
                Label={false}
              />
              <button
                type="button"
                className="event-create-add-tag-btn"
                disabled={loading}
                onClick={AddTagClickHandler}
              >
                Add Tag
              </button>
              <AddedTagList
                TagList={
                  watch("TagData")
                    ? watch("TagData")
                    : EventData && EventData.data.tag
                }
                TagHandler={removeTagHandler}
                isLoading={loading}
              />
            </div>
          </div>

          <div className="evntUserInfo bg-F9F9F9">
            <div className="heading">
              <h4>Location</h4>
              <p>({FormText.LocationText})</p>
            </div>
            <LocationMap
              errors={errors}
              register={register}
              countries={countries}
              watch={watch}
              locationError={locationError}
              addressForm={address}
              setAddressForm={setAddress}
              event={EventData}
            />
          </div>

          <div className="evntUserInfo bg-F9F9F9">
            <div className="heading">
              <h4>Select Event Type</h4>
              {/* <p>{FormText.TimingText}*</p> */}
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="wrapper">
                  <Input
                    element="radio"
                    defValue="single"
                    Id="option-1"
                    LabelCls="option option-1"
                    LabelPosition="bottom"
                    LabelHtml={FormLabal.singleDay.labelHtml}
                    Register={register}
                    Errors={errors}
                    selectDay={true}
                    FieldName="eventDayType"
                    clickHandler={() => setEventType("single")}
                    {...(eventType && {
                      checked: eventType === "single" ? true : false,
                    })}
                  />

                  <Input
                    element="radio"
                    defValue="multi"
                    selectDay={true}
                    Id="option-2"
                    LabelCls="option option-2"
                    LabelPosition="bottom"
                    LabelHtml={FormLabal.multiDay.labelHtml}
                    Register={register}
                    Errors={errors}
                    FieldName="eventDayType"
                    clickHandler={() => setEventType("multi")}
                    {...(eventType && {
                      checked: eventType !== "single" ? true : false,
                    })}
                    // checked={true}
                  />
                </div>
                <div className="heading">
                  <h4>{FormText.dateNTime}</h4>

                  {/* <p>{FormText.TimingText}*</p> */}
                </div>

                {ticketValidityError && (
                  <div className="row mb-3 d-flex justify-content-center text-align-center">
                    <div className="col-md-12 text-align-center">
                      <div
                        className="text-danger"
                        style={{
                          fontSize: "14px",
                        }}
                      >
                        {ticketValidityError}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <Input
                WrapperClass="col-md-6"
                element="date"
                pickerIcon
                InputClassName="event-create-input"
                placeholder={FormLabal.eventStartDate.placeHolder}
                Register={register}
                Errors={errors}
                FieldName="evtStartDate"
                customError={!!customError}
                Label={FormLabal.eventStartDate.label}
                ValidationArr={[{ Type: "required" }]}
              />

              {eventType === "multi" && (
                <Input
                  WrapperClass="col-md-6"
                  element="date"
                  pickerIcon
                  InputClassName="event-create-input"
                  placeholder={FormLabal.eventEndDate.placeHolder}
                  Register={register}
                  Errors={errors}
                  FieldName="evtEndDate"
                  Label={FormLabal.eventEndDate.label}
                  ValidationArr={[{ Type: "required" }]}
                />
              )}
            </div>
            <div className="row">
              <Input
                WrapperClass="col-md-6"
                defValue={EventData && EventData?.data?.eventTiming?.startTime}
                element="time"
                pickerIcon
                InputClassName="event-create-input"
                placeholder={FormLabal.startTime.placeHolder}
                Register={register}
                Errors={errors}
                FieldName="evtStartTime"
                Label={FormLabal.startTime.label}
                ValidationArr={[{ Type: "required" }]}
              />
              <Input
                WrapperClass="col-md-6"
                defValue={EventData && EventData.data?.eventTiming?.endTime}
                element="time"
                pickerIcon
                InputClassName="event-create-input"
                placeholder={FormLabal.endTime.placeHolder}
                Register={register}
                Errors={errors}
                FieldName="evtEndTime"
                Label={FormLabal.endTime.label}
                ValidationArr={[{ Type: "required" }]}
              />
            </div>
            {dateTimeError && (
              <div className="row mb-3 d-flex justify-content-center text-align-center">
                <div className="col-md-12 text-align-center">
                  <div
                    className="text-danger"
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    {dateTimeError}
                  </div>
                </div>
              </div>
            )}
            <div className="heading">
              <h4>{FormText.AdvancedSettiing}</h4>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Input
                  LabelCls="form-check-label"
                  LabelPosition="bottom"
                  element="checkbox"
                  CustomFormGroupCls="form-check-inline"
                  InputClassName="form-check-input custom-checkbox"
                  Register={register}
                  Errors={errors}
                  FieldName="displayStartTime"
                  Label={FormLabal.displayStartTime.label}
                  // checked={EventData && EventData.data.eventTiming.displayStartTime}
                />
                <Input
                  LabelCls="form-check-label"
                  LabelPosition="bottom"
                  CustomFormGroupCls="form-check-inline"
                  element="checkbox"
                  InputClassName="form-check-input custom-checkbox"
                  Register={register}
                  Errors={errors}
                  FieldName="displayEndTime"
                  Label={FormLabal.displayEndTime.label}
                  // checked={EventData && EventData.data.eventTiming.displayEndTime}
                />
              </div>
              {/* <Input
                element="select"
                WrapperClass="col-md-6"
                Register={register}
                Errors={errors}
                FieldName="timezone"
                Label={FormLabal.timezone.label}
                optionValue="value"
                optionLabel="LabelText"
                options={a}
              /> */}

              <Input
                element="select"
                WrapperClass="col-md-6"
                Label={FormLabal.timezone.label}
                FieldName="timeZone"
                options={a}
                optionValue="value"
                ValidationArr={[{ Type: "required" }]}
                optionLabel="LabelText"
                Register={register}
                Errors={errors}
              />
            </div>
          </div>

          <SubmitButtonGroup isLoading={loading} />
        </form>
      </div>
    </MainComponentWrapper>
  );
};

export default BasicInfoForm;
